import styled from 'styled-components';

export const PriceTableValue = styled.span`
  font-family: var(--font-roboto-mono);
`;
